import { Link, LinkProps } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import React from "react";

interface Props extends LinkProps {
  to: string;
}

export const SnLink: React.FC<Props> = (props) => {
  return (
    <Link
      as={RouterLink}
      fontWeight="500"
      color="#aed38a"
      textDecoration="underline"
      _visited={{ color: "#aed38a" }}
      {...props}>
    </Link>
  )
}